module.exports = __webpack_public_path__ + "static/azureLogo-441104121f45696d5db055686ef3f6f3.png";